import styled from 'styled-components';
import AirportIconSvg from './airport.svg';

const AirportIcon = styled(AirportIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
`;

export default AirportIcon;

